import { render, staticRenderFns } from "./Colaborador.vue?vue&type=template&id=52e6d930&scoped=true"
import script from "./Colaborador.vue?vue&type=script&lang=js"
export * from "./Colaborador.vue?vue&type=script&lang=js"
import style0 from "./Colaborador.vue?vue&type=style&index=0&id=52e6d930&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e6d930",
  null
  
)

export default component.exports